import "primeicons/primeicons.css";
import FormContainer from "../FormContainer";
import { useApiClient } from "../../../shared/customHooks";
import { kindergartenSearchForm } from "../../../shared/formObjects/application/kindergartenSearchForm";

export function KindergartenSearchComponent({ search }: { search: (kinderId: string, year: string) => void }) {
  const api = useApiClient("KindergartenChecker");

  const handleSearch = (values: any) => {
    const kindergartenName = values["kindergarten"].accountName === undefined ? "0" : values["kindergarten"].accountName;
    const year = values["year"] === "" ? 0 : values["year"];

    search(kindergartenName, year);
  };

  const deepClear = (values: any): any => {
    if (Array.isArray(values)) {
      return [];
    } else if (values !== null && typeof values === "object") {
      const cleared: Record<string, any> = {};
      for (const key in values) {
        cleared[key] = deepClear(values[key]);
      }
      return cleared;
    }
    return null;
  };

  return (
    <>
      <FormContainer
        disabled={false}
        apiClient={api}
        formBody={kindergartenSearchForm}
        showInternalNotes={false}
        customSubmit={handleSearch}
        customClear={deepClear}
        hideCancelButton={true}
        submitBtnTitle="Submit"
        hideClearButton={false}
        displayDirtyFormWarning={false}
      />
    </>
  );
}
